import { MessageCircle } from "lucide-react";
import { ADDRESS, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK, EMAIL, DOMAIN } from "../../data/site";

export const Footer = () => (
    <>
        <footer data-testid="site-footer" className="bg-navy relative overflow-hidden">
            <div className="absolute inset-0 blueprint-grid" />
            <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
                <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
                    <div className="md:col-span-5">
                        <p className="font-heading font-extrabold tracking-tight text-white text-2xl">ZAM ZAM FURNITURES</p>
                        <p className="font-mono text-[10px] tracking-[0.3em] text-gold mt-2">TASKLANCE® · FACTORY DIRECT SINCE DAY ONE</p>
                        <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-sm" data-testid="footer-seo-text">
                            Office Furniture Manufacturer in Hyderabad — Modular Workstations Erragadda,
                            TASKLANCE Office Chairs, executive desks, conference tables and Bulk Office
                            Furniture Supply across Telangana & Andhra Pradesh.
                        </p>
                    </div>
                    <div className="md:col-span-3">
                        <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500 mb-5">NAVIGATE</p>
                        <nav className="flex flex-col gap-3">
                            {[["Home", "#home"], ["About Us", "#about"], ["Products", "#products"], ["Custom Manufacturing", "#manufacturing"], ["Projects", "#projects"], ["Contact Us", "#contact"]].map(([label, href]) => (
                                <a key={href} href={href} className="text-sm text-slate-300 hover:text-gold transition-colors w-fit" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                                    {label}
                                </a>
                            ))}
                        </nav>
                    </div>
                    <div className="md:col-span-4">
                        <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500 mb-5">REACH THE FACTORY</p>
                        <p className="text-sm text-slate-300 leading-relaxed">{ADDRESS}</p>
                        <a href={PHONE_TEL} className="block mt-3 text-sm text-slate-300 hover:text-gold transition-colors" data-testid="footer-phone">{PHONE_DISPLAY}</a>
                        <p className="mt-3 text-sm text-slate-300">{EMAIL} · {DOMAIN}</p>
                    </div>
                </div>

                <p className="font-heading font-extrabold tracking-tighter text-outline-light text-[16vw] leading-none text-center select-none mt-10" data-testid="footer-wordmark">
                    TASKLANCE®
                </p>

                <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-4 font-mono text-[10px] tracking-[0.25em] text-slate-500">
                    <span data-testid="footer-copyright">© 2026 ZAM ZAM FURNITURES. ALL RIGHTS RESERVED.</span>
                    <span>MADE IN HYDERABAD, INDIA</span>
                </div>
            </div>
        </footer>

        <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
            data-testid="whatsapp-float-button"
        >
            <MessageCircle size={24} className="text-white" />
        </a>
    </>
);
